export default "__VITE_ASSET__3b2bdea7__"